import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { ExternalLink, LogOut } from "lucide-react";
import { api } from "@/lib/api";
import AdminLogin from "@/components/admin/AdminLogin";
import Overview from "@/components/admin/Overview";
import NewsManager from "@/components/admin/NewsManager";
import FilesManager from "@/components/admin/FilesManager";
import SettingsForm from "@/components/admin/SettingsForm";
import ClientDownload from "@/components/admin/ClientDownload";

const TABS = [
  ["overview", "Przegląd", Overview],
  ["news", "Newsy", NewsManager],
  ["files", "Pliki patcha", FilesManager],
  ["settings", "Ustawienia", SettingsForm],
  ["client", "Klient C#", ClientDownload],
];

export default function Admin() {
  const [params, setParams] = useSearchParams();
  const [authed, setAuthed] = useState(null);
  const tab = params.get("tab") || "overview";
  const current = TABS.find((t) => t[0] === tab) || TABS[0];
  const Current = current[2];

  useEffect(() => {
    document.title = "Admin - Koselig2";
    const m = document.createElement("meta");
    m.name = "robots"; m.content = "noindex, nofollow";
    document.head.appendChild(m);
    return () => m.remove();
  }, []);
  useEffect(() => { api.get("/auth/me").then(() => setAuthed(true)).catch(() => setAuthed(false)); }, []);
  const logout = async () => { await api.post("/auth/logout"); setAuthed(false); };

  if (authed === null) return <div className="min-h-screen bg-[#05060f]" />;
  if (!authed) return <AdminLogin onSuccess={() => setAuthed(true)} />;

  const item = (active) =>
    `w-full text-left px-3 py-2.5 rounded-md text-sm transition-colors ${active ? "bg-[#1d2b50] text-white" : "text-slate-400 hover:text-slate-100 hover:bg-white/5"}`;

  return (
    <div className="min-h-screen bg-[#05060f] text-slate-300 md:grid md:grid-cols-[220px_1fr]" data-testid="admin-panel">
      <aside className="bg-[#070919] border-b md:border-b-0 md:border-r border-[#2c2f52] p-3 md:p-4 flex md:flex-col gap-1 flex-wrap">
        <Link to="/" className="flex items-center gap-2 px-3 pb-3 md:pb-5 font-display text-slate-100" data-testid="admin-home-link">
          <img src="/assets/koselig-icon.png" alt="" className="w-6 h-6" /> Admin
        </Link>
        {TABS.map(([k, l]) => (
          <button key={k} onClick={() => setParams(k === "overview" ? {} : { tab: k })} data-testid={`admin-tab-${k}`} className={item(tab === k || (k === "overview" && !params.get("tab")))}>{l}</button>
        ))}
        <div className="md:mt-auto flex md:flex-col gap-1">
          <Link to="/launcher" className={`${item(false)} flex items-center gap-2`} data-testid="admin-launcher-link"><ExternalLink size={14} /> Podgląd launchera</Link>
          <button onClick={logout} className={`${item(false)} flex items-center gap-2 !text-red-300`} data-testid="admin-logout-btn"><LogOut size={14} /> Wyloguj</button>
        </div>
      </aside>
      <main className="px-5 md:px-10 py-8 min-w-0" key={tab}>
        <h1 className="font-display text-2xl text-slate-100 mb-6">{current[1]}</h1>
        <div className="launcher-rise"><Current goTab={(k) => setParams({ tab: k })} /></div>
      </main>
    </div>
  );
}
